import React, { useState } from "react";
import { FiUser, FiMail, FiPhone } from "react-icons/fi";
import contactVector from "../../image/ct4.png";
import axios from "axios";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { sendEmailMsg } from "../../service/EmailService";
const Contact = () => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    description: "",
  });

  const [errorForm, setErrorForm] = useState({
    first_name: "",
    email: "",
    mobile: "",
    description: "",
  });
  const handleReset = () => {
    setForm({
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      description: "",
    });
    setErrorForm({
      first_name: "",
      email: "",
      mobile: "",
      description: "",
    });
  };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const mobileRegex = /^[6-9]\d{9}$/;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    let error = "";

    if (name === "email") {
      if (!emailRegex.test(value)) {
        error = "Invalid email address";
      }
    }

    if (name === "mobile") {
      if (!mobileRegex.test(value)) {
        error = "Invalid mobile number";
      }
    }

    if (value && !error) {
      setErrorForm({ ...errorForm, [name]: "" });
    } else if (value) {
      setErrorForm({ ...errorForm, [name]: error });
    } else {
      setErrorForm({ ...errorForm, [name]: "" });
    }
  };

  const sendEmail = () => {
    setSubmitLoading(true);
    const payload = {
      from: { address: "noreply@intelisparkz.com" },
      to: [
        {
          email_address: {
            address: "contact@intelisparkz.com",
            name: "Sruti",
          },
        },
      ],
      subject: `Contact Form Submission from ${form.first_name} ${form.last_name}`,
      htmlbody: `
      <div>
        <h3>New Contact Message</h3>
        <p><strong>Name:</strong> ${form.first_name} ${form.last_name}</p>
        <p><strong>Email:</strong> ${form.email}</p>
        <p><strong>Mobile:</strong> ${form.mobile}</p>
        <p><strong>Description:</strong><br/>${form.description}</p>
      </div>
    `,
    };
    sendEmailMsg(payload)
      .then((res) => {
        console.log(res);
        toast.success("Data submitted successfully");
        handleReset();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Try again later");
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!form.first_name.trim()) {
      newErrors.first_name = "First name is required";
    }

    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = "Invalid email address";
    }

    if (!form.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!mobileRegex.test(form.mobile)) {
      newErrors.mobile = "Invalid mobile number";
    }

    if (!form.description.trim()) {
      newErrors.description = "Description is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorForm({ ...errorForm, ...newErrors });
      return;
    }
    sendEmail();
  };

  return (
    <section className="contact-section d-flex align-items-center" id="contact">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          {/* Left Illustration */}
          <div
            className="col-lg-6 mb-4 mb-lg-0 d-none d-md-block"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <img
              src={contactVector}
              alt="Contact Illustration"
              className="img-fluid"
              style={{ maxHeight: "550px" }}
            />
          </div>

          {/* Right Form */}
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div className="form-wrapper p-4 p-md-5">
              <h2 className="fw-bold text-center text-orange mb-4">
                Get In Touch
              </h2>
              <form onSubmit={handleSubmit}>
                <div className="row g-4">
                  {/* First Name */}
                  <div className="col-md-6">
                    <div className="input-group classy-input">
                      <span className="input-group-text bg-transparent border-0">
                        <FiUser className="text-orange" />
                      </span>
                      <input
                        type="text"
                        name="first_name"
                        className={`form-control ${
                          errorForm?.first_name ? "is-invalid" : ""
                        }`}
                        onChange={handleInputChange}
                        placeholder="First Name"
                      />
                    </div>
                    {errorForm?.first_name && (
                      <span className="small text-danger">
                        {errorForm?.first_name}
                      </span>
                    )}
                  </div>

                  {/* Last Name */}
                  <div className="col-md-6">
                    <div className="input-group classy-input">
                      <span className="input-group-text bg-transparent border-0">
                        <FiUser className="text-orange" />
                      </span>
                      <input
                        type="text"
                        name="last_name"
                        className={`form-control ${
                          errorForm?.last_name ? "is-invalid" : ""
                        }`}
                        onChange={handleInputChange}
                        placeholder="Last Name"
                      />
                    </div>
                    {errorForm?.last_name && (
                      <span className="small text-danger">
                        {errorForm?.last_name}
                      </span>
                    )}
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <div className="input-group classy-input">
                      <span className="input-group-text bg-transparent border-0">
                        <FiMail className="text-orange" />
                      </span>
                      <input
                        type="email"
                        name="email"
                        className={`form-control ${
                          errorForm?.email ? "is-invalid" : ""
                        }`}
                        onChange={handleInputChange}
                        placeholder="Email"
                      />
                    </div>
                    {errorForm?.email && (
                      <span className="small text-danger">
                        {errorForm?.email}
                      </span>
                    )}
                  </div>

                  {/* Phone */}
                  <div className="col-md-6">
                    <div className="input-group classy-input">
                      <span className="input-group-text bg-transparent border-0">
                        <FiPhone className="text-orange" />
                      </span>
                      <input
                        type="tel"
                        name="mobile"
                        className={`form-control ${
                          errorForm?.mobile ? "is-invalid" : ""
                        }`}
                        onChange={handleInputChange}
                        placeholder="Mobile Number"
                      />
                    </div>
                    {errorForm?.mobile && (
                      <span className="small text-danger">
                        {errorForm?.mobile}
                      </span>
                    )}
                  </div>

                  {/* Message */}
                  <div className="col-12">
                    <div className="input-group classy-input">
                      <textarea
                        rows="4"
                        name="description"
                        className={`form-control ${
                          errorForm?.description ? "is-invalid" : ""
                        }`}
                        onChange={handleInputChange}
                        placeholder="Your Message"
                      />
                    </div>
                    {errorForm?.description && (
                      <span className="small text-danger">
                        {errorForm?.description}
                      </span>
                    )}
                  </div>

                  {/* Submit Button */}
                  <div className="col-12 text-end">
                    <button
                      type="submit"
                      className="btn classy-btn mt-2"
                      disabled={submitLoading}
                    >
                      {submitLoading && (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-1"
                        />
                      )}
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
